import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
declare var window: any;
@Component
export default class RecruiterList extends Vue {
  get autoPopulateRecruiterList() {
    return vxm.configs.getGlobalConfigBooelanValue(
      'AUTO_POPULATE_RECRUITER_LIST',
    );
  }

  get recruiterListPlaceholder() {
    return this.autoPopulateRecruiterList
      ? 'Please select a recruiter'
      : this.$t('referafriend.form.recruiterselect');
  }

  get showRecruiterDropdown() {
    return !vxm.configs.getGlobalConfigBooelanValue(
      'HIDE_RECRUITER_SELECTION_IN_REFER_A_FRIEND',
    );
  }
}
